"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var FileNameInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FileNameInput, _PureComponent);

  function FileNameInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FileNameInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FileNameInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      modified: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (event) {
      var onChange = _this.props.onChange;
      onChange && onChange(event.target.value);

      _this.setState({
        modified: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(FileNameInput, [{
    key: "render",
    value: function render() {
      var value = this.props.value;
      var modified = this.state.modified;
      var isValid = !modified || !!value;
      var bsStyle = isValid ? null : 'error';
      var helpText = isValid ? null : 'A file name is required.';
      return _react.default.createElement(_TextField.default, {
        bsStyle: bsStyle,
        helpText: helpText,
        label: "File name",
        value: value,
        onChange: this.onChange
      });
    }
  }]);
  return FileNameInput;
}(_react.PureComponent);

exports.default = FileNameInput;
(0, _defineProperty2.default)(FileNameInput, "propTypes", {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired
});